// Const
import {
  GET_ORDERS,
  GET_ORDER_WITH_ID,
  UPDATE_ORDER_STATUS,
  ACTION_RETRIEVE_RUBIKA_ORDERS,
  SCHEDULE_ORDERS,
  CANCEL_ORDER,
  GET_LOGS,
  GET_ALL_ORDERS,
  UPDATE_ALL_ORDER_STATUS
} from './constants';

// Type
import { Payload, cancelPayload, PayloadAllUpdate } from './interfaces';

export function getOrdersAction(payload: Payload) {
  return {
    type: GET_ORDERS,
    payload,
  };
}

export function getAllOrdersAction(payload: Payload) {
  return {
    type: GET_ALL_ORDERS,
    payload,
  };
}


export function getOrderWithIdAction(payload: { id: number }) {
  return {
    type: GET_ORDER_WITH_ID,
    payload,
  };
}

export function updateOrderStatusActions(payload: {
  id: number;
  body: string;
  pagination: object;
}) {
  return {
    type: UPDATE_ORDER_STATUS,
    payload,
  };
}

export function actionRetrieveRubikaOrdersAction(payload: {
  date?: String;
  from?: number;
  to?: number;
}) {
  return {
    type: ACTION_RETRIEVE_RUBIKA_ORDERS,
    payload,
  };
}

export function scheduleOrdersAction(payload: { chance: String; date?: String }) {
  return {
    type: SCHEDULE_ORDERS,
    payload,
  };
}

export function cancelOrderAction(payload: cancelPayload) {
  return {
    type: CANCEL_ORDER,
    payload,
  };
}

export function getLogsAction(payload: { id: number }) {
  return {
    type: GET_LOGS,
    payload,
  };
}

export function updateAllOrderStatusActions(payload: PayloadAllUpdate) {
  return {
    type: UPDATE_ALL_ORDER_STATUS,
    payload,
  };
}
